import { useState } from "react";
import { Flex, Skeleton } from "antd";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import "./BucketwiseTable.scss";
import "../../../components/AgencyComp/UserComp/UserList.scss";
import { dummyResponse } from "./data";
import { formatCurrency, formatWithCommas } from "../../../assets/helpers";
import { useSelector } from "react-redux";


const BucketwiseTable = ({ data, loading, id }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { format } = useSelector(state => state.priceFormat);



  const bucketwiseData = data?.map((item, index) => ({
    key: index,
    cases: item.cases,
    agingBucket: item.bucket,
    odposValue: item.resolved.odpos.value,
    odposPerc: item.resolved.odpos.percentage,
    posValue: item.resolved.pos.value,
    posPerc: item.resolved.pos.percentage,
    totalOdposNos: item.total_odpos.numbers,
    totalOdposScore: item.total_odpos.crore,
    totalPosNos: item.total_pos.numbers,
    totalPosScore: item.total_pos.crore,
  }));



  const skeleton = <Skeleton.Input size="small" active />;
  const num = (v) => <span className="bw-num">{formatWithCommas(v) || "0"}</span>;
  const pctCell = (v) => (
    <span className="bw-pct">{`${Number(v) || 0}%`}</span>
  );
  const money = (v) => (
    <span className="bw-num">{formatCurrency(v, format)}</span>
  );

  const columns = [
    {
      title: "Cases",
      dataIndex: "cases",
      key: "cases",
      align: "right",
      width: 110,
      render: (text) => (loading ? skeleton : num(text)),
    },
    {
      title: "Aging Bucket",
      dataIndex: "agingBucket",
      key: "agingBucket",
      align: "center",
      width: 130,
      render: (text) =>
        loading ? skeleton : <span className="bw-bucket">{text ?? "—"}</span>,
    },
    {
      title: "Resolved",
      key: "resolved",
      align: "center",
      children: [
        {
          title: "ODPOS",
          key: "resolvedOdpos",
          align: "center",
          children: [
            {
              title: "Value",
              dataIndex: "odposValue",
              key: "odposValue",
              align: "right",
              render: (text) => (loading ? skeleton : num(text)),
            },
            {
              title: "Percentage",
              dataIndex: "odposPerc",
              key: "odposPerc",
              align: "right",
              render: (text) => (loading ? skeleton : pctCell(text)),
            },
          ],
        },
        {
          title: "POS",
          key: "resolvedPos",
          align: "center",
          children: [
            {
              title: "Value",
              dataIndex: "posValue",
              key: "posValue",
              align: "right",
              render: (text) => (loading ? skeleton : num(text)),
            },
            {
              title: "Percentage",
              dataIndex: "posPerc",
              key: "posPerc",
              align: "right",
              render: (text) => (loading ? skeleton : pctCell(text)),
            },
          ],
        },
      ],
    },
    {
      title: "Total ODPOS",
      key: "totalOdpos",
      align: "center",
      children: [
        {
          title: "Nos",
          dataIndex: "totalOdposNos",
          key: "totalOdposNos",
          align: "right",
          render: (text) => (loading ? skeleton : num(text)),
        },
        {
          title: "Crore",
          dataIndex: "totalOdposScore",
          key: "totalOdposScore",
          align: "right",
          render: (text) => (loading ? skeleton : money(text)),
        },
      ],
    },
    {
      title: "Total POS",
      key: "totalPos",
      align: "center",
      children: [
        {
          title: "Nos",
          dataIndex: "totalPosNos",
          key: "totalPosNos",
          align: "right",
          render: (text) => (loading ? skeleton : num(text)),
        },
        {
          title: "Crore",
          dataIndex: "totalPosScore",
          key: "totalPosScore",
          align: "right",
          render: (text) => (loading ? skeleton : money(text)),
        },
      ],
    },
  ];






  return (
    <Flex className="bucketwiseContainer">
      <ReusableTable
        columns={columns}
        dataSource={loading ? Array(8).fill({}) : bucketwiseData}
        rowKey="key"
        bordered
        pageSize={pageSize}
        CurrentPageNo={currentPage}
        totalItems={bucketwiseData?.length || 0}
        setPageSize={setPageSize}
        triggerChange={(page, size) => {
          setCurrentPage(page);
          setPageSize(size);
        }}
        className="bucketwiseTable"

      />
    </Flex>
  );
};

export default BucketwiseTable;
